import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaFacebook, FaGithub } from 'react-icons/fa';

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a
        href='https://www.linkedin.com/in/zineddine-benkhaled-b9b1a8195/'
        target='_blank'
        rel='noreferrer'
      >
        <BsLinkedin />
      </a>
      <a
        href='https://github.com/ZineddineBk09'
        target='_blank'
        rel='noreferrer'
      >
        <FaGithub />
      </a>
      <a
        href='https://www.facebook.com/zino.benkhaled'
        target='_blank'
        rel='noreferrer'
      >
        <FaFacebook />
      </a>
    </div>
  )
}

export default HeaderSocials